/** Legacy Navigation (intentionally empty); global <Header /> handles nav now. */
const Navigation = () => null;
export default Navigation;
